import { PaginationResponse, TransactionHistoryParams } from 'src/@types/search-params';
import { IBalanceLocalpay, TransactionHistory } from 'src/shared/interface/localpay.interface';
import request from '../request';

export const getBalance = async () => {
  const res = await request('get', `/api/Provider/get-balance/localpay`);

  if (res.isSucceeded) {
    return res.data.data;
  }
};
export const getTransactionHistory = async (params: any, distributorId: string) => {
  const res = await request<PaginationResponse<TransactionHistory>>(
    'get',
    '/api/Provider/get-all/localpay',
    { ...params, distributorId },
  );

  if (res.isSucceeded) {
    return res.data;
  }
};
export const getTransactionList = async (searchParams: any, distributorId: string) => {
  const res = await request<PaginationResponse<TransactionHistory>>(
    'get',
    '/api/Provider/get-all/transaction',
    { ...searchParams, distributorId },
  );

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getBalanceAccount = async () => {
  const res = await request<IBalanceLocalpay>('get', '/api/Provider/get-balance/localpay');
  if (res.isSucceeded) {
    return res.data;
  }
};
